import { CONTACT_EMAIL, APP_NAME, PORTIS_APP_ID, RPC_WALLETS } from './constants';
import { NETWORK_IDS } from './enums/network-ids.enum';
import { Network } from './enums/networks.enum';
import rpc from './rpc.config';

export interface WalletProviderInfo {
	walletName: string;
	display?: { desktop: boolean; mobile: boolean };
	preferred?: boolean;
	rpcUrl?: string;
	bridge?: string;
	apiKey?: string;
	label?: string;
	rpc?: { [networkId: string]: string };
	appName?: string;
	appUrl?: string;
	email?: string;
}

export const isRpcWallet = (walletName: string | null): boolean => {
	if (!walletName) return false;
	return RPC_WALLETS[walletName] ?? false;
};

export const getOnboardWallets = (): WalletProviderInfo[] => {
	const networkRPC = rpc[Network.Ethereum];
	return [
		{ walletName: 'metamask', preferred: true },
		{ walletName: 'coinbase' },
		{
			walletName: 'ledger',
			rpcUrl: networkRPC,
			preferred: true
		},
		{
			walletName: 'walletConnect',
			rpc: {
				'1': networkRPC,
				[NETWORK_IDS.BSC.toString()]: networkRPC
			},
			preferred: true
		},
		{ walletName: 'walletLink', rpcUrl: networkRPC, appName: APP_NAME },
		{
			walletName: 'portis',
			apiKey: PORTIS_APP_ID,
			label: 'Portis'
		},
		{
			walletName: 'trezor',
			appUrl: 'https://app.badger.finance/',
			email: CONTACT_EMAIL,
			rpcUrl: networkRPC,
			preferred: true
		}
	];
};

export const onboardWalletCheck = [
	{ checkName: 'derivationPath' },
	{ checkName: 'accounts' },
	{ checkName: 'connect' }
];
